import { api } from "../../services/jobtypes.service";
import { useRelationshipCheck } from "./useRelationshipCheck";

export const useFormRelationshipCheck = (id: string) =>
  useRelationshipCheck(id, api.checkFormRelationships);
